var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 25.2795L10.0001 10.717C10.0006 10.3929 10.0927 10.0755 10.2657 9.80146C10.4387 9.5274 10.6857 9.30781 10.9781 9.168C11.2705 9.02818 11.5964 8.97382 11.9183 9.01119C12.2403 9.04856 12.5451 9.17613 12.7977 9.37921L21.8229 16.6604C22.0227 16.8215 22.1839 17.0252 22.2947 17.2567C22.4054 17.4882 22.4629 17.7416 22.4629 17.9982C22.4629 18.2548 22.4054 18.5082 22.2947 18.7397C22.1839 18.9712 22.0227 19.1749 21.8229 19.336L12.7971 26.6172C12.5446 26.8207 12.2396 26.9487 11.9175 26.9864C11.5954 27.0241 11.2691 26.97 10.9764 26.8304C10.6841 26.6901 10.4373 26.4701 10.2646 26.1957C10.0919 25.9213 10.0002 25.6037 10.0001 25.2795Z",
    fill: "#100C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.aa80b47e9e81300d91dbebcd7a70349e.svg";
export { ForwardRef as ReactComponent };